















































import Vue from "vue";
import BasicInformationEdit from "@/stores/pages/components/BasicInformationEdit.vue";
import PaymentConfigurationEdit from "@/stores/pages/components/PaymentConfigurationEdit.vue";
import PosConfigurationEdit from "@/stores/pages/components/PosConfigurationEdit.vue";
import { storeService } from "@/common/services/StoreService";
import { CreateAdminStoreData } from "@/stores/pages/models/CreateAdminStoreData";

export default Vue.extend({
  name: "StoreCreator",
  components: {
    BasicInformationEdit,
    PaymentConfigurationEdit,
    PosConfigurationEdit,
  },
  data() {
    return {
      isFormValid: true,
      currentStep: 1,
      savingStore: false,
      createStoreData: new CreateAdminStoreData(),
    };
  },
  methods: {
    getNextButtonText(): string {
      return this.currentStep === 3 ? this.$t("common.save").toString() : this.$t("common.next").toString();
    },
    isDataValid(): boolean {
      return (
        (this.currentStep === 1 && this.createStoreData.isBasicInfoValid()) ||
        (this.currentStep === 2 && this.createStoreData.isPaymentConfigurationValid()) ||
        (this.currentStep === 3 && this.createStoreData.isPosConfigurationValid())
      );
    },
    async saveStore(): Promise<void> {
      this.savingStore = true;
      const toSave = JSON.parse(JSON.stringify(this.createStoreData));
      try {
        await storeService.createStore(toSave);
        this.$emit("updated");
      } catch (e) {
        this.savingStore = false;
      }
    },
    onClose(): void {
      this.savingStore = false;
      this.$emit("close");
    },
    nextStep(): void {
      if (this.currentStep < 3) {
        this.currentStep++;
      } else {
        this.saveStore();
      }
    },
  },
});
